var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader'),_c('b-card',[(!_vm.promotionCode)?_c('div',{staticClass:"text-center"},[_c('b-spinner')],1):_c('PromotionCodeForm',{attrs:{"promotion-code":_vm.promotionCode}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }